<!--
 * 文件名：labelRectificationList.vue
 * 描述：待整改标注任务列表（v26.3.3 数据标注·标注人员视角）。
 *       09-07 定稿：FBT 前端列表页 + 详情嵌标注系统待整改页（micro-app）。
 *       09-11 语义定稿：审核人员打回标注人员的任务 → 标注员整改 → 重新提交回审核（闭环）。
 * 数据层（09-11）：接口由 FBT 后端自建（F0，/label-task/task-page-list），
 *       数据结构照搬 fe task-page-list（stageCode=LABEL 视角 + rejectedFlag 驳回过滤——
 *       fe/中间件现无此过滤参数，为 F0 契约补充位，见 labelTaskApi buildTaskPageQuery）；
 *       F0 未就绪时走本地 mock（MOCK_ENABLED）。
-->
<template>
  <div class="content work_flow_wrap">
    <!-- 筛选区（SearchBar 组件，样式基准 productInformation，同 labelTemplateConf） -->
    <search-bar
      v-model="query"
      :conditions="conditions"
      @search="search"
      @reset="reset"
      @height-change="recalcLayout"
    ></search-bar>

    <!-- 列表 -->
    <div class="back-color-fff content-main-box" ref="tableBox" :style="'height:' + contentMainHeight + 'px'">
      <el-table
        ref="table"
        :data="tableData"
        v-loading="tableLoading"
        border
        stripe
        style="width: 100%"
        :height="tableHeight"
      >
        <el-table-column label="序号" width="50" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (query.pageIndex - 1) * query.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="projectName" label="项目名称" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column prop="taskPackageName" label="任务包名称" min-width="150" show-overflow-tooltip></el-table-column>
        <el-table-column label="标注类型" width="110" show-overflow-tooltip>
          <template slot-scope="scope">{{ labelTypeNameOf(scope.row.labelTypeCode) }}</template>
        </el-table-column>
        <el-table-column label="整改进度" width="110" header-align="center" align="right">
          <template slot-scope="scope">
            <span class="rectify-progress">{{ scope.row.itemFinishedNum || 0 }}/{{ scope.row.itemTotalNum || 0 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="90" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tag :type="rowStateOf(scope.row).done ? 'success' : 'warning'" size="small">
              {{ rowStateOf(scope.row).stateText }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="整改完成时间" width="160">
          <template slot-scope="scope">{{ scope.row.rectifyFinishTime || "-" }}</template>
        </el-table-column>
        <el-table-column label="操作" width="90" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button v-if="rowStateOf(scope.row).done" type="text" @click="toRectify(scope.row)">详情</el-button>
            <el-button v-else type="text" @click="toRectify(scope.row)">去整改</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        ref="pager"
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="pageChange"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="query.pageIndex"
        :page-size="query.pageSize"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar";
import { CONTRACT_URLS, MOCK_ENABLED, STAGE_CODES, PKG_STAGE, LABEL_TYPE_LIST, buildTaskPageQuery, mockTaskPageList, labelTypeName } from "./components/labelTaskApi";

export default {
  name: "labelRectificationList",
  components: { SearchBar },
  data() {
    return {
      // 引导估值：el-table 以 0 起步再在 mounted 里改值会丢高度更新（表格压成 0），先给非 0 初值，挂载后 recalcLayout 实测校正
      tableHeight: window.innerHeight - 320,
      contentMainHeight: window.innerHeight - 250,
      query: {
        projectName: "",
        labelTypeCode: "",
        state: "",
        pageIndex: 1,
        pageSize: 10,
      },
      tableData: [],
      total: 0,
      tableLoading: false,
      labelTypeOptions: LABEL_TYPE_LIST,
    };
  },
  computed: {
    conditions() {
      return [
        { key: "projectName", label: "项目名称", type: "input" },
        { key: "labelTypeCode", label: "标注类型", type: "select", options: this.labelTypeOptions },
        {
          key: "state",
          label: "状态",
          type: "select",
          options: [
            { label: "进行中", value: "ongoing" },
            { label: "已完成", value: "finished" },
          ],
        },
      ];
    },
  },
  mounted() {
    this.recalcLayout();
    window.addEventListener("resize", this.recalcLayout);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcLayout);
  },
  created() {
    this.search();
  },
  methods: {
    // 高度锚点实测：以内容盒顶部为锚，免去 header/条件行等魔法数；底部留 8px；取整避免小数像素
    recalcLayout() {
      if (!this.$refs.tableBox) return;
      const top = this.$refs.tableBox.getBoundingClientRect().top;
      this.contentMainHeight = Math.floor(window.innerHeight - top - 8);
      this.tableHeight = Math.floor(this.contentMainHeight - this.$refs.pager.$el.offsetHeight - 2);
      // 兜底：el-table 的 height watcher 有首帧丢更新场景（prop 已变而内部 layout 不动），nextTick 强制重设一次，已一致时幂等
      this.$nextTick(() => {
        if (this.$refs.table) this.$refs.table.layout.setHeight(this.tableHeight);
      });
    },
    rowStateOf(row) {
      // 整改视角不能用标注视角的 rowState（被驳回的包停在 REVIEW 阶段，会被判"已完成"堵死去整改入口）：
      // 整改随包生命周期存续，包未完结即"进行中"
      const done = row.currentStageCode === PKG_STAGE.COMPLETED;
      return { done, stateText: done ? "已完成" : "进行中" };
    },
    labelTypeNameOf(code) {
      return labelTypeName(code);
    },
    search() {
      this.query.pageIndex = 1;
      this.loadList();
    },
    reset() {
      this.query = { projectName: "", labelTypeCode: "", state: "", pageIndex: 1, pageSize: 10 };
      this.loadList();
    },
    loadList() {
      this.tableLoading = true;
      // rejectedFlag=Y：F0 契约补充位——fe/中间件无被驳回过滤参数（标注视角只分进行中/已完成），
      // 待整改=标注视角下被驳回的任务包集（F0 已实现，sales /label-task/task-page-list）
      const body = buildTaskPageQuery(this.query, STAGE_CODES.LABEL, { rejectedFlag: "Y" });
      const done = (data) => {
        this.tableLoading = false;
        this.tableData = data.records || [];
        this.total = data.totalRows || 0;
      };
      const fail = () => {
        this.tableLoading = false;
        this.tableData = [];
        this.total = 0;
      };
      if (MOCK_ENABLED) {
        mockTaskPageList(body).then(done).catch(fail);
        return;
      }
      this.api
        .postJson(`/${serverConfig.msSalesPerformService}${CONTRACT_URLS.taskPageList}`, body)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) done(res.data.data || {});
          else fail();
        })
        .catch(fail);
    },
    pageChange(page) {
      this.query.pageIndex = page;
      this.loadList();
    },
    handleSizeChange(size) {
      this.query.pageSize = size;
      this.loadList();
    },
    toRectify(row) {
      // 不传 allowModifyFlag：待整改页恒可编辑（2026-10-16 口径③：闭环=整包提交，提交前不转只读，见 labelToolDetail embedIsView），
      // 该参数在 rectify 分支不消费，属 fe 透传死参数
      // 整页导航进入详情：micro-app 子应用按 name keep-alive 复用（iframe 沙箱档禁 v-if 原地重挂），
      // SPA 跳转会带入上一页（审核/其他任务）的子应用实例（残留旧 mode/旧任务列表）——整页加载保证重建
      const { href } = this.$router.resolve({
        path: "/labelToolDetail",
        query: {
          mode: "rectify",
          projectId: row.labelStudioProjectId,
          taskPackageGuid: row.guid,
          taskId: row.labelStudioTaskId || row.firstLabelStudioTaskId || "",
          stageRuleCode: row.stageRuleCode || "",
          projectName: row.projectName,
          taskTitle: row.taskPackageName,
        },
      });
      window.location.href = href;
    },
  },
};
</script>

<style scoped>
.rectify-progress {
  font-size: 12px;
  color: #606266;
}
</style>
